module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ep1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("We may make our plans, but God has the last word.")])]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("—PROVERBS 16:1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06cc1122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph1.vue
// module id = 72
// module chunks = 0